export default __webpack_public_path__ + "dcf0729e16abd29c4cba83bbd86f2c6f.svg";